import { useState, useEffect } from "react";
import { addDoc, collection, updateDoc, doc } from "firebase/firestore";
import { MdClose } from "react-icons/md";
import { db } from "../../../firebase";
import { useAuth } from "../../../context/AuthContext";
import "./index.css";

const TransactionForm = ({ onClose, onAdded, editData }) => {
  const { user } = useAuth();

  const [title, setTitle] = useState("");
  const [amount, setAmount] = useState("");
  const [category, setCategory] = useState("Food");
  const [date, setDate] = useState("");
  const [notes, setNotes] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (editData) {
      setTitle(editData.title);
      setAmount(editData.amount);
      setCategory(editData.category);
      setDate(editData.date);
      setNotes(editData.notes || "");
    }
  }, [editData]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title || !amount || !date) {
      setError("Please fill all required fields");
      return;
    }

    try {
      setLoading(true);

      if (editData) {
        await updateDoc(doc(db, "transactions", editData.id), {
          title,
          amount: Number(amount),
          category,
          date,
          notes,
        });
      } else {
        await addDoc(collection(db, "transactions"), {
          userId: user.uid,
          title,
          amount: Number(amount),
          category,
          date,
          notes,
          createdAt: new Date(),
        });
      }

      // notify parent to refresh list
      if (onAdded) onAdded();

      // close popup
      if (onClose) onClose();
    } catch (err) {
      console.log(err);
      setError("Failed to add transaction");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="transaction-popup-container">
      <div className="transaction-modal">
        <div className="transaction-header">
          <h2>{editData ? "Update Transaction" : "Add Transaction"}</h2>
          <button className="close-btn" onClick={onClose}>
            <MdClose />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="transaction-form">
          <label>Title *</label>
          <input
            type="text"
            placeholder="e.g. Grocery shopping"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />

          <label>Amount *</label>
          <input
            type="number"
            placeholder="Enter amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />

          <label>Category</label>
          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option>Food</option>
            <option>Rent</option>
            <option>Transport</option>
            <option>Shopping</option>
            <option>Entertainment</option>
            <option>Other</option>
          </select>

          <label>Date *</label>
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />

          <label>Notes</label>
          <textarea
            placeholder="Add Expense notes..."
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />

          {error && <p className="transaction-error">{error}</p>}

          <button className="submit-btn" disabled={loading}>
            {loading
              ? "Saving..."
              : editData
                ? "Update Transaction"
                : "Add Transaction"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default TransactionForm;
